import { render, staticRenderFns } from "./paymentPassword.vue?vue&type=template&id=6645317e&scoped=true&"
import script from "./paymentPassword.vue?vue&type=script&lang=ts&"
export * from "./paymentPassword.vue?vue&type=script&lang=ts&"
import style0 from "./paymentPassword.vue?vue&type=style&index=0&id=6645317e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6645317e",
  null
  
)

export default component.exports